"use client";

import Link from "next/link";
import { XMarkIcon, SparklesIcon } from "@heroicons/react/24/outline";
import { useState, useContext } from "react";

import { LocaleContext } from "@/app/context/locale-context";
import getLanguage from "@/app/utils/getlanguage";
import translation from "./locale/index.json";

export default function FirstVisitPromoWidget() {
  const [isVisible, setIsVisible] = useState(true);
  const locale = useContext(LocaleContext);
  const content = getLanguage(translation, locale);

  if (!isVisible || !content) return null;

  // Split price into main amount and subtitle
  const [priceAmount, priceSubtitle] = content.price.split('\n');

  return (
    <Link
      href={`/${locale}/first-visit-to-the-dentist`}
      className="fixed top-[100px] right-2 sm:top-[120px] sm:right-4 md:right-6 lg:top-[180px] lg:right-8 z-50 group"
    >
      <div className="relative w-24 h-24 xs:w-28 xs:h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 lg:w-52 lg:h-52 rounded-full bg-gradient-to-br from-blue-500 via-indigo-600 to-purple-700 shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 cursor-pointer overflow-hidden flex flex-col items-center justify-center p-2 xs:p-3 sm:p-4 md:p-5">
        <div className="absolute inset-0 bg-grid-white/[0.05] animate-pulse" />
        
        <div className="relative z-10 text-center flex flex-col items-center justify-center h-full gap-0.5 xs:gap-1 sm:gap-1.5 md:gap-2">
          <div className="flex items-center gap-0.5 xs:gap-1 text-yellow-300">
            <SparklesIcon className="w-2.5 h-2.5 xs:w-3 xs:h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-5 lg:h-5" />
            <span className="text-[7px] xs:text-[8px] sm:text-[10px] md:text-xs lg:text-xs font-bold uppercase tracking-wide whitespace-pre-line leading-tight">{content.badge}</span>
          </div>
          <div className="text-base xs:text-lg sm:text-2xl md:text-3xl lg:text-3xl font-black text-white leading-tight">{priceAmount}</div>
          {priceSubtitle && (
            <div className="text-[6px] xs:text-[7px] sm:text-[9px] md:text-[10px] lg:text-[10px] text-white/80 font-semibold leading-tight">{priceSubtitle}</div>
          )}
          <p className="text-[6px] xs:text-[7px] sm:text-[9px] md:text-xs lg:text-xs text-white/90 font-semibold leading-tight max-w-xs whitespace-pre-line px-1">
            {content.offer}
          </p>
        </div>

        <div className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/10 backdrop-blur-sm" />
      </div>

      <button
        onClick={(e) => {
          e.preventDefault();
          setIsVisible(false);
        }}
        className="absolute -top-1 -right-1 z-50 bg-white rounded-full p-0.5 xs:p-1 shadow-lg hover:bg-gray-100 transition-colors"
        aria-label="Close promotion"
      >
        <XMarkIcon className="w-3 h-3 xs:w-4 xs:h-4 text-gray-700" />
      </button>
    </Link>
  );
}
